import { Box } from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { applyEvent, Prefectures } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_FAC026 } from "./api/request";
import { fakeTableList, infoHeadTitleList, schema } from "./parts";
import _ from "lodash";

/**
 * SCRW050006 施設転換後非加入　新規登録
 * @return SCRW050006 施設転換後非加入　新規登録
 */
const SCRW050006 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const [statusInfoTableList, setStatusInfoTableList] = useState<any>({
    infoHeadTitleList: infoHeadTitleList,
    infoBodyList: [],
  });
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  // 契約者番号
  const contractorNo = businessState.common?.contractorNo;
  // 申請ID
  const applyId = location.state?.applyId;
  // メモ
  const [memo, setMemo] = useState("");
  // 申請等状態定義の状態id
  const [statusCd, setStatusCd] = useState<string>();
  // 照会画面への反映コードチェック状態
  const [isApplyCodeChecked, setIsApplyCodeChecked] = useState<string>("");

  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    let resArr = stateFakeTableList.current;
    // 契約者（法人）名
    resArr.find((item) => item.keyword === "contractorName")!.text =
      (contractorNo ?? "") + ":" + (businessState.common?.contractorName ?? "");

    // 施設転換後非加入参照API 呼び出し
    try {
      const res = await httpAPI_FAC026({
        applyId: applyId,
      });

      if (res.resultCd === "I0000") {
        // 初期表示
        // 申請等状態定義の状態id
        setStatusCd(res.latestApplyStatus!);
        // 転換予定日
        resArr.find(
          (item) => item.keyword === "changeoverDueDate"
        )!.setDefaultValue = res.changeoverDueDate;
        // 施設名
        const bFacilityName = resArr.find(
          (item) => item.keyword === "bFacilityName"
        )!;
        bFacilityName.selectPropsList = [
          {
            value: res.bFacilityNo,
            label: (res.bFacilityNo ?? "") + ":" + (res.bFacilityName ?? ""), // 転換前名称
          },
        ];
        bFacilityName.setDefaultValue = res.bFacilityNo;
        // 転換前施設種類
        const bFacilityKind = resArr.find(
          (item) => item.keyword === "bFacilityKind"
        )!;
        bFacilityKind.selectPropsList = [
          {
            value: res.bFacilityKind,
            label:
              (res.bFacilityKind ?? "") + ":" + (res.bFacilityKindName ?? ""), // 転換前名称
          },
        ];
        bFacilityKind.setDefaultValue = res.bFacilityKind;
        // 転換前施設所在地郵便番号
        resArr.find(
          (item) => item.keyword === "bFacilityZipcode"
        )!.setDefaultValue = res.bFacilityZipcode;
        // 転換前施設所在地
        let resObj = {
          prefectures: TkGetCode(Prefectures, res.bFacilityPrefectureCd)!,
          city: res.bFacilityAddressCity!,
          address: res.bFacilityAddressOthers!,
        };
        resArr.find(
          (item) => item.keyword === "bFacilityAddress"
        )!.valueObject = resObj;

        // 転換後施設名称
        const aFacilityName = resArr.find(
          (item) => item.keyword === "aFacilityName"
        )!;
        aFacilityName.selectPropsList = [
          {
            value: res.aFacilityNo,
            label: (res.aFacilityNo ?? "") + ":" + (res.aFacilityName ?? ""), // 転換後名称
          },
        ];
        aFacilityName.setDefaultValue = res.aFacilityNo;
        // 転換後施設種類
        aFacilityName.setDefaultValue = res.aFacilityNo;
        // 転換後施設種類
        const aFacilityKind = resArr.find(
          (item) => item.keyword === "aFacilityKind"
        )!;
        aFacilityKind.selectPropsList = [
          {
            value: res.aFacilityKind,
            label:
              (res.aFacilityKind ?? "") + ":" + (res.aFacilityKindName ?? ""), // 転換後名称
          },
        ];
        aFacilityKind.setDefaultValue = res.aFacilityKind;
        // 転換後施設所在地郵便番号
        resArr.find(
          (item) => item.keyword === "aFacilityZipcode"
        )!.setDefaultValue = res.aFacilityZipcode;
        // 転換後施設所在地
        let resObjAfter = {
          prefectures: TkGetCode(Prefectures, res.aFacilityPrefectureCd),
          city: res.aFacilityAddressCity!,
          address: res.aFacilityAddressOthers!,
        };
        resArr.find(
          (item) => item.keyword === "aFacilityAddress"
        )!.valueObject = resObjAfter;
        // 備考
        resArr.find((item) => item.keyword === "remark")!.setDefaultValue =
          res.remark;
        const statusList: any = [];
        res.statusList?.forEach((memo: any) => {
          const data = [
            {
              children: memo.managerName,
            },
            {
              children: memo.process,
            },
            {
              children: memo.createDate,
              align: "center",
            },
            {
              children: memo.processComment,
            },
          ];
          statusList.push(data);
        });
        setStatusInfoTableList(statusList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }

      setStateInfoList([...resArr]);
    } catch {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCheckAndSubmit = async (data: keyof typeof applyEvent) => {
    const applyEventNo = applyEvent[data];
    if (
      ![
        applyEvent["受理"],
        applyEvent["契約者に差戻し"],
        applyEvent["上長承認"],
        applyEvent["担当者に差戻し"],
        applyEvent["課長代理確認"],
      ].includes(applyEventNo)
    )
      return;

    // 申請状況更新API 呼び出し
    try {
      const res = await httpAPI_APP016({
        applyId,
        applyEvent: applyEventNo,
        contractorNo,
        reason: memo,
        inquiryCode: isApplyCodeChecked,
        screenId: "SCRW050006",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // メモ、チェックボックス入力値変更
  const handleChangeData = (data: any) => {
    if (data?.target?.type === "input") {
      setMemo(data?.target?.value);
    } else {
      setIsApplyCodeChecked(data?.target?.type ? "2" : "");
    }
  };

  return (
    <Box className="SCRW050006" data-testid="SCRW050006PageForTest">
      <TkKikoStepper
        applicationFlowType={"TYPE3"}
        businessType={"JOB-21"}
        applicationStatus={statusCd as ITkViewButtonJudgementStatus}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW050006_01}</TkInfoManual>
      <TkFakeTable
        list={stateInfoList}
        ruleSchema={schema}
        showButton={false}
      />
      {/* メモ、コメント、チェックボックス */}
      <TkMemo
        headList={infoHeadTitleList}
        bodyList={statusInfoTableList}
        onChange={handleChangeData}
      />

      <Box className="btn">
        <TkBackButton mr />
        <TkViewButtonJudgement
          flowType={"TYPE3"}
          Status={statusCd as ITkViewButtonJudgementStatus}
          onClick={onCheckAndSubmit}
        />
      </Box>
    </Box>
  );
};

export default SCRW050006;
